import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const ResearchFunction = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Research Function</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) conducts research to support standardization, quality improvement, and regulatory compliance across industries.
          </p>
          <p className="subtitle">
            Research underpins evidence-based decision-making, innovation, and the development of standards aligned with international best practices.
          </p>
        </div>
      </section>

      {/* === Research Activities Section === */}
      <section className="intro-section">
        <h2 className="section-title">Key Research Activities</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Development and review of national and sector-specific standards</li>
              <li>Scientific and technical studies to inform policy and regulation</li>
              <li>Market and consumer research to assess product quality and safety</li>
              <li>Evaluation of new materials, products, and technologies</li>
              <li>Collaborative research with regional and international standardization bodies</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Research on measurement methods, testing, and calibration procedures</li>
              <li>Assessment of compliance trends and regulatory effectiveness</li>
              <li>Documentation and publication of research findings and reports</li>
              <li>Capacity building for MBS staff in research methodologies</li>
              <li>Support for innovation and continuous improvement in industry practices</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Impact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Impact of Research</h2>
        <p>
          MBS research enhances the development of standards, informs regulatory decisions, supports quality assurance, and promotes innovation. 
          It ensures that national standards remain relevant, effective, and internationally aligned.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Research</h2>
        <p>
          For inquiries, collaboration, or more information on research activities, please contact the MBS Research Department.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:research@mbs.mw">research@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 555</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          MBS research function ensures evidence-based standards development, supports innovation, and strengthens quality and compliance in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default ResearchFunction;
